export default __webpack_public_path__ + "static/media/rezerve-heading.f96a9ada.png";